require('gsap');
require('./mobile/Main');
// eslint-disable-next-line import/no-unresolved
require('javascripts/trill-description/dist/scripts/main');
